// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W-WF","content":"styles_content__HQg2z","tableWrap":"styles_tableWrap__1HsFO"};